import { render, staticRenderFns } from "./OrganizationMapPage.vue?vue&type=template&id=397f3cf9&"
import script from "./OrganizationMapPage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationMapPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports